
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/radio",
      function () {
        return require("private-next-pages/radio.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/radio"])
      });
    }
  